import { atom } from "recoil";
import { getDefaultUserSearchBindingModel } from "../services/UserService";

const UserSearchState = atom({
    key: 'UserSearchState',
    default: getDefaultUserSearchBindingModel(),
});

export default UserSearchState;